export const TABLE = {
  DEFAULT_PAGINATION: 10,
  PAGINATION_OPTIONS: [
    {
      label: "10",
      value: 10,
    },
    {
      label: "20",
      value: 20,
    },
    {
      label: "50",
      value: 50,
    },
    // {
    //   label: "100",
    //   value: 100,
    // },
  ],
};

export const constants = {
  SUCCESS: "Success",
  DEFAULT: "default",
  ERROR_MESSAGES: {
    SOMETHING_WENT_WRONG: "Something went wrong!",
    UNAUTHORIZED: "Unauthorized Access",
  },
};

export const ORDER_STATUS = {
  ORDERED: "ordered",
  SHIPPED: "shipped",
  DELIVERED: "delivered",
};

export const STATUS = {
  SUCCESS: "success",
  COMPLETED: "completed",
  PROCESSING: "processing",
  IN_PROGRESS: "in_progress",
  INPROGRESS: "inprogress",
  STARTED: "started",
  FAILED: "failed",
} as const;

export const PATIENT_RELATIONS = [
  { label: "Mother", value: "mother" },
  { label: "Father", value: "father" },
  { label: "Brother", value: "brother" },
  { label: "Sister", value: "sister" },
  { label: "Friend", value: "friend" },
  { label: "Relative", value: "relative" },
  { label: "Other", value: "other" },
];

export const DIET_PLAN_TITLE = "Diet Plan";
